var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 19.9062H7.875C3.12375 19.9062 1.09375 17.8762 1.09375 13.125V7.875C1.09375 3.12375 3.12375 1.09375 7.875 1.09375H13.125C17.8762 1.09375 19.9062 3.12375 19.9062 7.875V13.125C19.9062 17.8762 17.8762 19.9062 13.125 19.9062ZM7.875 2.40625C3.84125 2.40625 2.40625 3.84125 2.40625 7.875V13.125C2.40625 17.1587 3.84125 18.5937 7.875 18.5937H13.125C17.1587 18.5937 18.5937 17.1587 18.5937 13.125V7.875C18.5937 3.84125 17.1587 2.40625 13.125 2.40625H7.875Z",
    fill: "#9A9AA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 8.53125H7.21875C6.86 8.53125 6.5625 8.23375 6.5625 7.875C6.5625 7.51625 6.86 7.21875 7.21875 7.21875H13.7812C14.14 7.21875 14.4375 7.51625 14.4375 7.875C14.4375 8.23375 14.14 8.53125 13.7812 8.53125Z",
    fill: "#9A9AA9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 13.7812H7.21875C6.86 13.7812 6.5625 13.4837 6.5625 13.125C6.5625 12.7663 6.86 12.4688 7.21875 12.4688H13.7812C14.14 12.4688 14.4375 12.7663 14.4375 13.125C14.4375 13.4837 14.14 13.7812 13.7812 13.7812Z",
    fill: "#9A9AA9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistoryIcon);
export default __webpack_public_path__ + "static/media/order-history-icon.c897af2ff285c81dd4977c4c02ebec01.svg";
export { ForwardRef as ReactComponent };